import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/village/profile',
            name: 'village_profile',
            component: () => import("./views/profile.vue"),
            meta: {
                hasBar: true,
                bottomCutFixed: true,
            }
        },
        {
            path: '/profile/notificationsConfig',
            name: 'village_notificationsConfig',
            component: () => import("./views/notificationsConfig.vue"),
            meta: {
            }
        },
        {
            path: '/profile/profileData',
            name: 'village_profileData',
            component: () => import("./views/profileData.vue"),
            meta: {
            }
        },
        {
            path: '/profile/fiscalDataPage',
            name: 'village_fiscalDataPage',
            component: () => import("./views/fiscalDataPage.vue"),
            meta: {
            }
        },
        {
            path: '/profile/purchaseHistory',
            name: 'village_purchaseHistory',
            component: () => import("./views/purchaseHistory.vue"),
            meta: {
            }
        },
        {
            path: '/profile/oblivion',
            name: 'village_oblivion',
            component: () => import("./views/oblivion.vue"),
            meta: {
            }
        },
        {
            path: '/profile/faq/:nodeIdentifier', 
            name: 'village_faq',
            component: () => import('./views/faq.vue'),
            meta: {
            }
        },
    ];
};